export const drawerWidth = 256

export const headerHeight = 75

export const footerHeight = 256

export const backgroundGradient = 'linear-gradient(90deg, #4459af 3%, #4459af 19.47%, #a060d7 99.22%)'
